import { render } from "./Footer.vue?vue&type=template&id=0a5a088a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0a5a088a&scoped=true&lang=css"

import exportComponent from "/Users/programmer2/Desktop/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5a088a"]])

export default __exports__